import { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, Text } from 'src/Components'
import styles from './ReadMore.module.scss'

const defaultProps = {
  text: ' ',
  truncateCount: 1,
}

const ReadMore = ({ text, truncateCount }) => {
  const [truncate, setTruncate] = useState(true)
  const handleTruncate = () => setTruncate(!truncate)

  return (
    <Text
      data-qa='read-more'
      element='p'
      variant='neutralCool'
      variantCount='900'
    >
      {text && text.length > truncateCount ? (
        <>
          {truncate ? (
            <>
              {text.substring(0, truncateCount)}
              ...{' '}
            </>
          ) : (
            text
          )}
          {truncate && (
            <Button
              minimal
              onClick={handleTruncate}
              className={styles.viewMore}
            >
              <FormattedMessage
                id='HomeSearch.listingDetails.description.showMore'
                defaultMessage='Show More'
              />
            </Button>
          )}
        </>
      ) : (
        text
      )}
    </Text>
  )
}

ReadMore.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  truncateCount: PropTypes.number,
}

ReadMore.defaultProps = defaultProps
export default ReadMore
